import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { COUNTRIES } from 'api/query-keys.ts';
import type { CountryRes } from 'api/swagger';

export const useGetCountries = () => {
  return useQuery<CountryRes[]>({
    queryKey: [COUNTRIES],
    queryFn: async () => {
      const { data } = await http.get<CountryRes[]>(`/v1/countries`);

      return data;
    },
    retry: 2,
    cacheTime: Infinity,
    staleTime: Infinity,
  });
};
